import { PageSizes, rgb } from 'pdf-lib';
import { DomReportBase } from './dom-report-base';

/**
 * Generates the Dominion Energy "Initial / Quick" home audit PDF report by
 * filling the FormHOReport_HomeEvalQuick.pdf AcroForm template.
 */
export class DomInitialReport extends DomReportBase {

    async doDoc(ri: any): Promise<Blob> {
        this.repInfo = ri;

        const pdfPath = "assets/DOM1/FormHOReport_HomeEvalQuick.pdf";
        const {
            pdfDoc, font, form,
            pngImage, pngDims,
            pngRedImage, pngRedDims,
            pngCheckImage, pngCheckDims,
            pngGraphImage, pngGraphDims,
            pngHoneywellImage, pngHoneywellDims,
            headerBanner
        } = await this.loadReportAssets(pdfPath);

        let pages = pdfDoc.getPages();

        // handle variable number of pages
        let pageOffset = 0;

        // Page 1
        form.getTextField('ReportHeader').setText(this.getValue(this.repInfo.REPORTNAME.Value));
        form.getTextField('DateOfService').setText("Service Date: " + this.getArrayValue(this.repInfo.CUSTOMER.Value, 'Header', 'INSTALL DATE', 'Value'));

        form.getTextField('HomeReportTitle').setText(this.getValue(this.repInfo["Home Energy Report"].Header));
        form.getTextField('PreparedBy').setText(this.getArrayValue(this.repInfo["Home Energy Report"]["Sub Headers"].Value, 'Header', 'Header1', 'Value'));
        form.getTextField('BroughtBy').setText(this.getArrayValue(this.repInfo["Home Energy Report"]["Sub Headers"].Value, 'Header', 'Header2', 'Value'));
        form.getTextField('InThisReport').setText(this.getArrayValue(this.repInfo["Home Energy Report"]["Sub Headers"].Value, 'Header', 'Header3', 'Value'));

        form.getTextField('AuditorName').setText(this.getArrayValue(this.repInfo["AUDITOR"].Values, 'Header', 'Auditor Name', 'Value'));
        form.getTextField('AuditorCompanyName').setText(this.getArrayValue(this.repInfo["AUDITOR"].Values, 'Header', 'Auditor Company Name', 'Value'));
        form.getTextField('AuditorPhone').setText("Phone: " + this.formatPhone(this.getArrayValue(this.repInfo["AUDITOR"].Values, 'Header', 'Auditor Phone', 'Value')));
        form.getTextField('AuditorEmail').setText("Email: " + this.getArrayValue(this.repInfo["AUDITOR"].Values, 'Header', 'Auditor Email', 'Value'));

        const tmpStreet = this.getArrayValue(this.repInfo["AUDITOR"].Values, 'Header', 'Auditor Street Number', 'Value')
            + " " + this.getArrayValue(this.repInfo["AUDITOR"].Values, 'Header', 'Auditor Street Name', 'Value');

        const tmpCity = this.getArrayValue(this.repInfo["AUDITOR"].Values, 'Header', 'Auditor city', 'Value')
            + ", " + this.getArrayValue(this.repInfo["AUDITOR"].Values, 'Header', 'Auditor state', 'Value')
            + "  " + this.getArrayValue(this.repInfo["AUDITOR"].Values, 'Header', 'Auditor zip', 'Value');

        form.getTextField('AuditorStreet').setText(tmpStreet);
        form.getTextField('AuditorCity').setText(tmpCity);

        form.getTextField('Bulletin1').setText("- " + this.getArrayValue(this.repInfo["Home Energy Report"]["In this Report"].Value, 'Header', 'Bulletin1', 'Value'));
        form.getTextField('Bulletin2').setText("- " + this.getArrayValue(this.repInfo["Home Energy Report"]["In this Report"].Value, 'Header', 'Bulletin2', 'Value'));
        form.getTextField('Bulletin3').setText("- " + this.getArrayValue(this.repInfo["Home Energy Report"]["In this Report"].Value, 'Header', 'Bulletin3', 'Value'));

        // page 2
        form.getTextField('CustName').setText(this.getArrayValue(this.repInfo["CUSTOMER"].Value, 'Header', 'CUSTOMER NAME', 'Value'));
        form.getTextField('CustNameReport').setText(this.getArrayValue(this.repInfo["CUSTOMER"].Value, 'Header', 'CUSTOMER NAME', 'Value') + "'s Report");
        form.getTextField('CustNameDear').setText("Dear " + this.getArrayValue(this.repInfo["CUSTOMER"].Value, 'Header', 'CUSTOMER NAME', 'Value'));

        const custStreet = this.getArrayValue(this.repInfo["CUSTOMER"].Value, 'Header', 'CUSTOMER STREETNUMBER', 'Value')
            + " " + this.getArrayValue(this.repInfo["CUSTOMER"].Value, 'Header', 'CUSTOMER STREETNAME', 'Value');

        const custCity = this.getArrayValue(this.repInfo["CUSTOMER"].Value, 'Header', 'CUSTOMER CITY', 'Value')
            + ", " + this.getArrayValue(this.repInfo["CUSTOMER"].Value, 'Header', 'CUSTOMER STATE', 'Value')
            + "  " + this.getArrayValue(this.repInfo["CUSTOMER"].Value, 'Header', 'CUSTOMER ZIP', 'Value');

        form.getTextField('CustStreet').setText(custStreet);
        form.getTextField('CustCity').setText(custCity);

        form.getTextField('CustPara1').setText(this.getArrayValue(this.repInfo["CUSTOMER REPORT"].Value, 'Header', 'Paragraph1', 'Value'));
        form.getTextField('CustPara2').setText(this.getArrayValue(this.repInfo["CUSTOMER REPORT"].Value, 'Header', 'Paragraph2', 'Value'));
        form.getTextField('CustPara3').setText(this.getArrayValue(this.repInfo["CUSTOMER REPORT"].Value, 'Header', 'Paragraph3', 'Value'));
        form.getTextField('CustPara4').setText(this.getArrayValue(this.repInfo["CUSTOMER REPORT"].Value, 'Header', 'Paragraph4', 'Value'));

        // page 3
        form.getTextField('EstEngSavings').setText(this.getValue(this.repInfo["Savings Data"]["Estimated Energy Savings"]) + " kWh");
        form.getTextField('EstTotRebate').setText("$" + this.getValue(this.repInfo["Savings Data"]["Est. Total Rebate Incentive"]));


        // bar graph
        let thirdPage = pages[2];
        thirdPage.drawImage(pngGraphImage, {
            x: 36,
            y: 460,
            width: pngGraphDims.width,
            height: pngGraphDims.height,
        });

        const currentUsageValue = Number(this.repInfo["Savings Data"]['Current Usage']) || 0;
        const estimatedSavingsValue = Number(this.repInfo["Savings Data"]['Estimated Energy Savings']) || 0;

        if (currentUsageValue > 0) {
            const { currentUsageWidth, proposedUsageWidth } = this.getUsageBarMetrics(currentUsageValue, estimatedSavingsValue);

            thirdPage.drawRectangle({
                x: 53,
                y: 535,
                width: currentUsageWidth,
                height: 15,
                color: rgb(0.035, 0.51, 0.78)
            });
            thirdPage.drawRectangle({
                x: 53,
                y: 520,
                width: proposedUsageWidth,
                height: 15,
                color: rgb(0.02, 0.525, 0.263)
            });
        }

        // installed improvements
        let measureYOffset = 345;
        const col1x = 35;
        const col2x = 350;
        const col3x = 453;
        const col4x = 574;

        let str, textWidth;

        this.repInfo["Improvements Installed During Assessment"].Values.forEach(element => {
            if (measureYOffset < 80) {
                // paginate
                pdfDoc.insertPage(3 + pageOffset, PageSizes.Letter);
                pages = pdfDoc.getPages();
                thirdPage = pages[3 + pageOffset];
                measureYOffset = 670;
                pageOffset++;

                this.drawContinuationHeader(thirdPage, pngHoneywellImage, pngHoneywellDims, headerBanner);
            }
            thirdPage.moveTo(col1x, measureYOffset);
            thirdPage.drawText(this.getValue(element["Improvement"]), { size: 10 });

            str = this.getValue(element["Quantity"]);
            textWidth = font.widthOfTextAtSize(str, 10);
            thirdPage.moveTo(col2x - textWidth, measureYOffset);
            thirdPage.drawText(this.getValue(element["Quantity"]), { size: 10 });

            str = this.getValue(element["First Year Savings"]);
            textWidth = font.widthOfTextAtSize(str, 10);
            thirdPage.moveTo(col3x - textWidth, measureYOffset);
            thirdPage.drawText(this.getValue(element["First Year Savings"]), { size: 10 });

            str = str = "$" + this.getValue(element["Rebate Incentive"]);
            textWidth = font.widthOfTextAtSize(str, 10)
            thirdPage.moveTo(col4x - textWidth, measureYOffset);
            thirdPage.drawText(str, { size: 10 });

            measureYOffset -= 12;
        });

        // suggested improvements
        if (this.repInfo["Suggested Improvements with Available Rebates"].Values.length > 0) {
            if (measureYOffset < 200) {
                // paginate
                pdfDoc.insertPage(3 + pageOffset, PageSizes.Letter);
                pages = pdfDoc.getPages();
                thirdPage = pages[3 + pageOffset];
                measureYOffset = 670;
                pageOffset++;

                this.drawContinuationHeader(thirdPage, pngHoneywellImage, pngHoneywellDims, headerBanner);
            } else {
                measureYOffset -= 72;
            }

            // do header
            thirdPage.drawRectangle({
                x: 30.0,
                y: measureYOffset,
                width: 550,
                height: 25,
                color: rgb(0.44, 0.50, 0.53)
            });

            thirdPage.moveTo(42, measureYOffset + 7);
            thirdPage.drawText('Suggested Improvements', { color: rgb(1, 1, 1), size: 16 });

            measureYOffset -= 40;

            thirdPage.drawRectangle({
                x: 30.0,
                y: measureYOffset,
                width: 550,
                height: 40,
                color: rgb(0.957, 0.957, 0.957)
            });

            thirdPage.moveTo(42, measureYOffset + 25);
            thirdPage.drawText('Improvements', { color: rgb(0.278, 0.329, 0.396), size: 10 });
            thirdPage.moveTo(310, measureYOffset + 25);
            thirdPage.drawText('Quantity', { color: rgb(0.278, 0.329, 0.396), size: 10 });
            thirdPage.moveTo(380, measureYOffset + 25);
            thirdPage.drawText('First Year Savings', { color: rgb(0.278, 0.329, 0.396), size: 10 });
            thirdPage.moveTo(405, measureYOffset + 10);
            thirdPage.drawText('(kWh)', { color: rgb(0.278, 0.329, 0.396), size: 10 });
            thirdPage.moveTo(485, measureYOffset + 25);
            thirdPage.drawText('Rebate Incentive', { color: rgb(0.278, 0.329, 0.396), size: 10 });

            measureYOffset -= 20;

            this.repInfo["Suggested Improvements with Available Rebates"].Values.forEach(element => {
                if (measureYOffset < 80) {
                    // paginate
                    pdfDoc.insertPage(3 + pageOffset, PageSizes.Letter);
                    pages = pdfDoc.getPages();
                    thirdPage = pages[3 + pageOffset];
                    measureYOffset = 670;
                    pageOffset++;

                    this.drawContinuationHeader(thirdPage, pngHoneywellImage, pngHoneywellDims, headerBanner);
                }
                thirdPage.moveTo(col1x, measureYOffset);
                thirdPage.drawText(this.getValue(element["Improvement"]), { size: 10 });

                str = this.getValue(element["Quantity"]);
                textWidth = font.widthOfTextAtSize(str, 10);
                thirdPage.moveTo(col2x - textWidth, measureYOffset);
                thirdPage.drawText(this.getValue(element["Quantity"]), { size: 10 });

                str = this.getValue(element["First Year Savings"]);
                textWidth = font.widthOfTextAtSize(str, 10);
                thirdPage.moveTo(col3x - textWidth, measureYOffset);
                thirdPage.drawText(this.getValue(element["First Year Savings"]), { size: 10 });

                str = str = "$" + this.getValue(element["Rebate Incentive"]);
                textWidth = font.widthOfTextAtSize(str, 10)
                thirdPage.moveTo(col4x - textWidth, measureYOffset);
                thirdPage.drawText(str, { size: 10 });

                measureYOffset -= 12;
            });
        }

        // page 4
        form.getTextField('baTotal').setText('$' + this.getValue(this.repInfo["Savings Data"]['Est. Total Rebate Incentive']).toString());

        form.getTextField('baAccountHolder').setText(this.getArrayValue(this.repInfo["CUSTOMER"].Value, 'Header', 'CUSTOMER NAME', 'Value'));
        form.getTextField('baEmail').setText(this.getArrayValue(this.repInfo["CUSTOMER"].Value, 'Header', 'CUSTOMER EMAIL', 'Value'));
        form.getTextField('baPhone').setText(this.formatPhone(this.getArrayValue(this.repInfo["CUSTOMER"].Value, 'Header', 'CUSTOMER PHONE', 'Value')));

        form.getTextField('baBuildingType').setText(this.getArrayValue(this.repInfo["Building"].Values, 'Header', 'Building Type', 'Value'));
        form.getTextField('baFoundationType').setText(this.getArrayValue(this.repInfo["Building"].Values, 'Header', 'Foundation Type', 'Value'));
        form.getTextField('baRoofType').setText(this.getArrayValue(this.repInfo["Building"].Values, 'Header', 'Roof Type', 'Value'));
        form.getTextField('baNumOccupants').setText(this.getArrayValue(this.repInfo["Building"].Values, 'Header', 'Number of Occupants', 'Value'));
        form.getTextField('baYearBuilt').setText(this.getArrayValue(this.repInfo["Building"].Values, 'Header', 'Year Built', 'Value'));
        form.getTextField('baFloorArea').setText(this.getArrayValue(this.repInfo["Building"].Values, 'Header', 'Floor Area', 'Value'));
        form.getTextField('baRentOwn').setText(this.getArrayValue(this.repInfo["Building"].Values, 'Header', 'Renter Or Owner', 'Value'));
        form.getTextField('baNumFloors').setText(this.getArrayValue(this.repInfo["Building"].Values, 'Header', 'Number of Floors', 'Value'));
        form.getTextField('baNumBedrooms').setText(this.getArrayValue(this.repInfo["Building"].Values, 'Header', 'Number of Bedrooms', 'Value'));

        form.getTextField('baDisclaimer').setText(this.getValue(this.repInfo["SAVINGS_INFO"].Value));

        // page 5
        form.getTextField('hwSystem').setText(this.getArrayValue(this.repInfo["Hot Water Attributes"].Values, 'Header', 'Hot Water System', 'Value'));
        form.getTextField('hwFuel').setText(this.getArrayValue(this.repInfo["Hot Water Attributes"].Values, 'Header', 'Hot Water Fuel', 'Value'));
        form.getTextField('hwUsage').setText(this.getArrayValue(this.repInfo["Hot Water Attributes"].Values, 'Header', 'Hot Water Usage', 'Value'));

        form.getTextField('hwGenInfo').setText(this.getArrayValue(this.repInfo["Hot Water"].Value, 'Header', 'Paragraph1', 'Value'));

        form.getTextField('hwHeader').setText(this.getValue(this.repInfo['Hot Water'].Header));

        form.getTextField('hwIndicator').setText(this.repInfo['Hot Water']['Est. Annual  Savings']);

        const fifthPage = pages[4 + pageOffset];

        // the "General Information" bar here is still static/baked into
        // the template - cover it so a fresh one can be redrawn wherever
        // hwHeader ends up after any Potential-Measures-driven shift
        this.coverStaticHeaderBar(form, 'hwHeader', fifthPage);

        const hwDetailsBottom = this.getFieldRectOnPage(form, 'hwUsage', fifthPage)?.y ?? 575.547;
        let hwContentBottomY = hwDetailsBottom - 10;
        if (this.repInfo['Hot Water']['Potential Measures'].length > 0) {
            const hwMeasuresBarY = hwDetailsBottom - 10 - 25;
            this.drawSectionBar(fifthPage, 'Potential Measures', hwMeasuresBarY);

            fifthPage.drawImage(pngRedImage, {
                x: 36,
                y: 540,
                width: pngRedDims.width,
                height: pngRedDims.height,
            });

            fifthPage.drawImage(pngCheckImage, {
                x: 123.5,
                y: hwMeasuresBarY - 30,
                width: pngCheckDims.width,
                height: pngCheckDims.height,
            });

            hwContentBottomY = this.drawMultilineList(fifthPage, 160, hwMeasuresBarY - 15, this.repInfo['Hot Water']['Potential Measures']);
        }

        // no continuation-page overflow support for this section - just a
        // local shift so General Information clears Potential Measures
        this.shiftFieldsBelowOverflow(form, 'hwHeader', ['hwHeader', 'hwGenInfo'], hwContentBottomY, fifthPage);
        this.drawHeaderBarWhereverFieldIs(form, 'hwHeader', [fifthPage]);

        if (this.repInfo['Hot Water']['Potential Measures'].length < 1) {
            if (this.repInfo['Hot Water']['Savings Indicator'] === 'Green') {
                fifthPage.drawImage(pngImage, {
                    x: 36,
                    y: 540,
                    width: pngDims.width,
                    height: pngDims.height,
                });
            } else {
                // if not green
                fifthPage.drawRectangle({
                    x: 430.0,
                    y: 650.2,
                    width: 143.9,
                    height: 43.75,
                    color: rgb(1.0, 0.6471, 0.0)
                });
            }
        }

        // page 6
        form.getTextField('lEstEngSavings').setText(this.getValue(this.repInfo['Lighting']['Est. Annual  Savings']));

        form.getTextField('lPara1').setText(this.getArrayValue(this.repInfo["Lighting"].Value, 'Header', 'Paragraph1', 'Value'));
        form.getTextField('lPara2').setText(this.getArrayValue(this.repInfo["Lighting"].Value, 'Header', 'Paragraph2', 'Value'));
        form.getTextField('lPara3').setText(this.getArrayValue(this.repInfo["Lighting"].Value, 'Header', 'Paragraph3', 'Value'));
        form.getTextField('lPara4').setText(this.getArrayValue(this.repInfo["Lighting"].Value, 'Header', 'Paragraph4', 'Value'));

        form.getTextField('lBulletin1').setText(this.getArrayValue(this.repInfo["Lighting"].Value, 'Header', 'Bulletin1', 'Value'));
        form.getTextField('lBulletin2').setText(this.getArrayValue(this.repInfo["Lighting"].Value, 'Header', 'Bulletin2', 'Value'));
        form.getTextField('lBulletin3').setText(this.getArrayValue(this.repInfo["Lighting"].Value, 'Header', 'Bulletin3', 'Value'));

        form.getTextField('lHeader').setText(this.getValue(this.repInfo['Lighting'].Header));

        const sectionName = "Improvements Installed During Assessment";

        form.getTextField('lBathroom').setText(this.getValue(this.repInfo[sectionName]['No. Installed in Bathroom'], '0'));
        form.getTextField('lBedroom').setText(this.getValue(this.repInfo[sectionName]['No. Installed in Bedroom'], '0'));
        form.getTextField('lDiningRoom').setText(this.getValue(this.repInfo[sectionName]['No. Installed in Dining Room'], '0'));
        form.getTextField('lExterior').setText(this.getValue(this.repInfo[sectionName]['No. Installed in Exterior'], '0'));
        form.getTextField('lGarage').setText(this.getValue(this.repInfo[sectionName]['No. Installed in Garage'], '0'));
        form.getTextField('lHallway').setText(this.getValue(this.repInfo[sectionName]['No. Installed in Hallway'], '0'));
        form.getTextField('lKitchen').setText(this.getValue(this.repInfo[sectionName]['No. Installed in Kitchen'], '0'));
        form.getTextField('lLivingRoom').setText(this.getValue(this.repInfo[sectionName]['No. Installed in Living Room'], '0'));

        const sixthPage = pages[5 + pageOffset];

        // the "General Information" bar and bullet glyphs here are still
        // static/baked into the template - cover them so fresh ones can be
        // redrawn wherever their fields end up after any Potential-Measures shift
        this.coverStaticHeaderBar(form, 'lHeader', sixthPage);
        this.coverStaticBullets(form, ['lBulletin1', 'lBulletin2', 'lBulletin3'], sixthPage);

        const lDetailsBottom = this.getFieldRectOnPage(form, 'lGarage', sixthPage)?.y ?? 494.035;
        let lContentBottomY = lDetailsBottom - 10;
        if (this.repInfo['Lighting']['Potential Measures'].length > 0) {
            const lMeasuresBarY = lDetailsBottom - 10 - 25;
            this.drawSectionBar(sixthPage, 'Potential Measures', lMeasuresBarY);

            sixthPage.drawImage(pngRedImage, {
                x: 36,
                y: 540,
                width: pngRedDims.width,
                height: pngRedDims.height,
            });

            sixthPage.drawImage(pngCheckImage, {
                x: 123.5,
                y: lMeasuresBarY - 30,
                width: pngCheckDims.width,
                height: pngCheckDims.height,
            });

            lContentBottomY = this.drawMultilineList(sixthPage, 160, lMeasuresBarY - 15, this.repInfo['Lighting']['Potential Measures']);
        }

        // no continuation-page overflow support for this section - just a
        // local shift so General Information clears Potential Measures
        this.shiftFieldsBelowOverflow(form, 'lHeader', ['lHeader', 'lPara1', 'lPara2', 'lPara3', 'lBulletin1', 'lBulletin2', 'lBulletin3', 'lPara4'], lContentBottomY, sixthPage);
        this.drawHeaderBarWhereverFieldIs(form, 'lHeader', [sixthPage]);
        this.drawBulletsForFields(form, sixthPage, ['lBulletin1', 'lBulletin2', 'lBulletin3']);

        if (this.repInfo['Lighting']['Potential Measures'].length < 1) {
            if (this.repInfo['Lighting']['Savings Indicator'] === 'Green') {
                sixthPage.drawImage(pngImage, {
                    x: 36,
                    y: 540,
                    width: pngDims.width,
                    height: pngDims.height,
                });
            } else {
                // if not green
                sixthPage.drawRectangle({
                    x: 429.83,
                    y: 608.2,
                    width: 143.9,
                    height: 43.75,
                    color: rgb(1.0, 0.6471, 0.0)
                });
            }
        }

        // page 7b (no Appliances page in the Initial report)
        form.getTextField('stHeatingSystemType').setText(this.getArrayValue(this.repInfo["Heating and Cooling Attributes"].Values, 'Header', 'Heating System Type', 'Value'));
        form.getTextField('stPrimaryHeatingFuel').setText(this.getArrayValue(this.repInfo["Heating and Cooling Attributes"].Values, 'Header', 'Primary Heating Fuel', 'Value'));
        form.getTextField('stPrimaryPctContrib').setText(this.getArrayValue(this.repInfo["Heating and Cooling Attributes"].Values, 'Header', 'Primary Pct Contribution', 'Value'));
        form.getTextField('stSecondaryHeatingFuel').setText(this.getArrayValue(this.repInfo["Heating and Cooling Attributes"].Values, 'Header', 'Secondary Heating Fuel', 'Value'));
        form.getTextField('stCoolingSystemType').setText(this.getArrayValue(this.repInfo["Heating and Cooling Attributes"].Values, 'Header', 'Cooling System Type', 'Value'));
        form.getTextField('stHeatingSetpoint').setText(this.getArrayValue(this.repInfo["Heating and Cooling Attributes"].Values, 'Header', 'Heating Thermostat Setpoint', 'Value'));
        form.getTextField('stCoolingSetpoint').setText(this.getArrayValue(this.repInfo["Heating and Cooling Attributes"].Values, 'Header', 'Cooling Thermostat Setpoint', 'Value'));

        form.getTextField('stHeader').setText(this.getValue(this.repInfo['Smart Thermostats'].Header));

        form.getTextField('stPara1').setText(this.getArrayValue(this.repInfo["Smart Thermostats"].Value, 'Header', 'Paragraph1', 'Value'));
        form.getTextField('stPara2').setText(this.getArrayValue(this.repInfo["Smart Thermostats"].Value, 'Header', 'Paragraph2', 'Value'));
        form.getTextField('stPara3').setText(this.getArrayValue(this.repInfo["Smart Thermostats"].Value, 'Header', 'Paragraph3', 'Value'));
        form.getTextField('stPara4').setText(this.getArrayValue(this.repInfo["Smart Thermostats"].Value, 'Header', 'Paragraph4', 'Value'));

        form.getTextField('stBullet1').setText(this.getArrayValue(this.repInfo["Smart Thermostats"].Value, 'Header', 'Bulletin1', 'Value'));
        form.getTextField('stBullet2').setText(this.getArrayValue(this.repInfo["Smart Thermostats"].Value, 'Header', 'Bulletin2', 'Value'));
        form.getTextField('stBullet3').setText(this.getArrayValue(this.repInfo["Smart Thermostats"].Value, 'Header', 'Bulletin3', 'Value'));

        form.getTextField('stIndicator').setText(this.getValue(this.repInfo['Smart Thermostats']['Est. Annual  Savings']));

        const seventhPage = pages[6 + pageOffset];

        // the "General Information" bar and bullet glyphs here are still
        // static/baked into the template - cover them so fresh ones can be
        // redrawn wherever their fields end up after any Potential-Measures shift
        this.coverStaticHeaderBar(form, 'stHeader', seventhPage);
        this.coverStaticBullets(form, ['stBullet1', 'stBullet2', 'stBullet3'], seventhPage);

        const stDetailsBottom = this.getFieldRectOnPage(form, 'stCoolingSetpoint', seventhPage)?.y ?? 510.16;
        let stContentBottomY = stDetailsBottom - 10;
        if (this.repInfo['Smart Thermostats']['Potential Measures'].length > 0) {
            const stMeasuresBarY = stDetailsBottom - 10 - 25;
            this.drawSectionBar(seventhPage, 'Potential Measures', stMeasuresBarY);

            seventhPage.drawImage(pngRedImage, {
                x: 36,
                y: 540,
                width: pngRedDims.width,
                height: pngRedDims.height,
            });

            seventhPage.drawImage(pngCheckImage, {
                x: 123.5,
                y: stMeasuresBarY - 30,
                width: pngCheckDims.width,
                height: pngCheckDims.height,
            });

            stContentBottomY = this.drawMultilineList(seventhPage, 160, stMeasuresBarY - 15, this.repInfo['Smart Thermostats']['Potential Measures']);
        }

        // no continuation-page overflow support for this section - just a
        // local shift so General Information clears Potential Measures
        this.shiftFieldsBelowOverflow(form, 'stHeader', ['stHeader', 'stPara1', 'stPara2', 'stPara3', 'stPara4', 'stBullet1', 'stBullet2', 'stBullet3'], stContentBottomY, seventhPage);
        this.drawHeaderBarWhereverFieldIs(form, 'stHeader', [seventhPage]);
        this.drawBulletsForFields(form, seventhPage, ['stBullet1', 'stBullet2', 'stBullet3']);

        if (this.repInfo['Smart Thermostats']['Potential Measures'].length < 1) {
            if (this.repInfo['Smart Thermostats']['Savings Indicator'] === 'Green') {
                seventhPage.drawImage(pngImage, {
                    x: 36,
                    y: 540,
                    width: pngDims.width,
                    height: pngDims.height,
                });
            } else {
                // if not green
                seventhPage.drawRectangle({
                    x: 431.0,
                    y: 650.2,
                    width: 143.9,
                    height: 43.75,
                    color: rgb(1.0, 0.6471, 0.0)
                });
            }
        }

        // page 8
        form.getTextField('hcPara1').setText(this.getArrayValue(this.repInfo["Heating and Cooling"].Value, 'Header', 'Paragraph1', 'Value'));
        form.getTextField('hcPara2').setText(this.getArrayValue(this.repInfo["Heating and Cooling"].Value, 'Header', 'Paragraph2', 'Value'));
        form.getTextField('hcPara3').setText(this.getArrayValue(this.repInfo["Heating and Cooling"].Value, 'Header', 'Paragraph3', 'Value'));
        form.getTextField('hcPara4').setText(this.getArrayValue(this.repInfo["Heating and Cooling"].Value, 'Header', 'Paragraph4', 'Value'));
        form.getTextField('hcPara5').setText(this.getArrayValue(this.repInfo["Heating and Cooling"].Value, 'Header', 'Paragraph5', 'Value'));

        form.getTextField('hcBullet1').setText(this.getArrayValue(this.repInfo["Heating and Cooling"].Value, 'Header', 'Bulletin1', 'Value'));
        form.getTextField('hcBullet2').setText(this.getArrayValue(this.repInfo["Heating and Cooling"].Value, 'Header', 'Bulletin2', 'Value'));
        form.getTextField('hcBullet3').setText(this.getArrayValue(this.repInfo["Heating and Cooling"].Value, 'Header', 'Bulletin3', 'Value'));

        form.getTextField('hcIndicator').setText(this.getValue(this.repInfo['Heating and Cooling']['Est. Annual  Savings']));

        const eighthPage = pages[7 + pageOffset];

        // the "General Information" bar and bullet glyphs here are still
        // static/baked into the template - this section shares 'stHeader'
        // as its anchor field (same as Smart Thermostats, no separate
        // hcHeader field exists) - cover them so fresh ones can be redrawn
        // wherever their fields end up after any Potential-Measures shift
        this.coverStaticHeaderBar(form, 'stHeader', eighthPage);
        this.coverStaticBullets(form, ['hcBullet1', 'hcBullet2', 'hcBullet3'], eighthPage);

        const hcDetailsBottom = this.getFieldRectOnPage(form, 'stCoolingSetpoint', eighthPage)?.y ?? 596;
        let hcContentBottomY = hcDetailsBottom - 10;
        if (this.repInfo['Heating and Cooling']['Potential Measures'].length > 0) {
            const hcMeasuresBarY = hcDetailsBottom - 10 - 25;
            this.drawSectionBar(eighthPage, 'Potential Measures', hcMeasuresBarY);

            eighthPage.drawImage(pngRedImage, {
                x: 36,
                y: 540,
                width: pngRedDims.width,
                height: pngRedDims.height,
            });

            eighthPage.drawImage(pngCheckImage, {
                x: 123.5,
                y: hcMeasuresBarY - 30,
                width: pngCheckDims.width,
                height: pngCheckDims.height,
            });

            hcContentBottomY = this.drawMultilineList(eighthPage, 160, hcMeasuresBarY - 15, this.repInfo['Heating and Cooling']['Potential Measures']);
        }

        // no continuation-page overflow support for this section - just a
        // local shift so General Information clears Potential Measures
        this.shiftFieldsBelowOverflow(form, 'stHeader', ['stHeader', 'hcPara1', 'hcPara2', 'hcPara3', 'hcPara4', 'hcPara5', 'hcBullet1', 'hcBullet2', 'hcBullet3'], hcContentBottomY, eighthPage);
        this.drawHeaderBarWhereverFieldIs(form, 'stHeader', [eighthPage]);
        this.drawBulletsForFields(form, eighthPage, ['hcBullet1', 'hcBullet2', 'hcBullet3']);

        if (this.repInfo['Heating and Cooling']['Potential Measures'].length < 1) {
            if (this.repInfo['Smart Thermostats']['Savings Indicator'] === 'Green') {
                eighthPage.drawImage(pngImage, {
                    x: 36,
                    y: 540,
                    width: pngDims.width,
                    height: pngDims.height,
                });
            } else {
                // if not green
                eighthPage.drawRectangle({
                    x: 426.0,
                    y: 650.2,
                    width: 148,
                    height: 43.75,
                    color: rgb(1.0, 0.6471, 0.0)
                });
            }
        }

        // page 9
        form.getTextField('ductPara1').setText(this.getArrayValue(this.repInfo["Duct Sealing & Duct Insulation"].Value, 'Header', 'Paragraph1', 'Value'));
        form.getTextField('ductPara2').setText(this.getArrayValue(this.repInfo["Duct Sealing & Duct Insulation"].Value, 'Header', 'Paragraph2', 'Value'));
        form.getTextField('ductHeader').setText(this.getValue(this.repInfo['Duct Sealing & Duct Insulation'].Header));
        form.getTextField('ductIndicator').setText(this.getValue(this.repInfo['Duct Sealing & Duct Insulation']['Est. Annual  Savings']));

        const ninethPage = pages[8 + pageOffset];
        if (this.repInfo['Duct Sealing & Duct Insulation']['Potential Measures'].length > 0) {
            ninethPage.drawRectangle({
                x: 123.5,
                y: 596.0,
                width: 450,
                height: 25,
                color: rgb(0.76, 0.28, 0.07)
            });

            form.getTextField("ductMeasureTitle").setText("Potential Measures");

            ninethPage.drawImage(pngRedImage, {
                x: 36,
                y: 540,
                width: pngRedDims.width,
                height: pngRedDims.height,
            });

            ninethPage.drawImage(pngCheckImage, {
                x: 123.5,
                y: 560,
                width: pngCheckDims.width,
                height: pngCheckDims.height,
            });

            let asOffset = 574;
            this.repInfo['Duct Sealing & Duct Insulation']['Potential Measures'].forEach(element => {
                ninethPage.moveTo(160, asOffset);
                ninethPage.drawText(element, { size: 10 });
                asOffset -= 12;
            });
        } else
            if (this.repInfo['Duct Sealing & Duct Insulation']['Savings Indicator'] === 'Green') {
                ninethPage.drawImage(pngImage, {
                    x: 36,
                    y: 540,
                    width: pngDims.width,
                    height: pngDims.height,
                });
            } else {
                // if not green
                ninethPage.drawRectangle({
                    x: 426.0,
                    y: 650.2,
                    width: 148,
                    height: 43.75,
                    color: rgb(1.0, 0.6471, 0.0)
                });
            }

        // page 10
        form.getTextField('asPara1').setText(this.getArrayValue(this.repInfo["Air Sealing"].Value, 'Header', 'Paragraph1', 'Value'));
        form.getTextField('asHeader').setText(this.getValue(this.repInfo['Air Sealing']['Header']));
        form.getTextField('asIndicator').setText(this.getValue(this.repInfo['Air Sealing']['Est. Annual  Savings']));

        form.getTextField('asNumOfFloors').setText(this.getArrayValue(this.repInfo["Air Sealing Attributes"].Values, 'Header', 'Number of Floors', 'Value'));
        form.getTextField('asConditioned').setText(this.getArrayValue(this.repInfo["Air Sealing Attributes"].Values, 'Header', 'Conditioned Area', 'Value'));
        form.getTextField('asBlower').setText(this.getArrayValue(this.repInfo["Air Sealing Attributes"].Values, 'Header', 'Blower Door Measurement', 'Value'));
        form.getTextField('asLeakage').setText(this.getArrayValue(this.repInfo["Air Sealing Attributes"].Values, 'Header', 'Estimated Building Leakage', 'Value'));

        const tenthPage = pages[9 + pageOffset];
        if (this.repInfo['Air Sealing']['Potential Measures'].length > 0) {
            tenthPage.drawRectangle({
                x: 123.5,
                y: 555.0,
                width: 450,
                height: 25,
                color: rgb(0.76, 0.28, 0.07)
            });

            form.getTextField("asMeasureTitle").setText("Potential Measures");

            tenthPage.drawImage(pngRedImage, {
                x: 36,
                y: 540,
                width: pngRedDims.width,
                height: pngRedDims.height,
            });

            tenthPage.drawImage(pngCheckImage, {
                x: 123.5,
                y: 525,
                width: pngCheckDims.width,
                height: pngCheckDims.height,
            });

            let asOffset = 542;
            this.repInfo['Air Sealing']['Potential Measures'].forEach(element => {
                tenthPage.moveTo(160, asOffset);
                tenthPage.drawText(element, { size: 10 });
                asOffset -= 12;
            });
        } else
            if (this.repInfo['Air Sealing']['Savings Indicator'] === 'Green') {
                tenthPage.drawImage(pngImage, {
                    x: 36,
                    y: 540,
                    width: pngDims.width,
                    height: pngDims.height,
                });
            } else {
                // if not green
                tenthPage.drawRectangle({
                    x: 426.0,
                    y: 650.2,
                    width: 148,
                    height: 43.75,
                    color: rgb(1.0, 0.6471, 0.0)
                });
            }

        // page 11
        form.getTextField('insHeader').setText(this.getValue(this.repInfo['Insulation']['Header']));
        form.getTextField('insPara1').setText(this.getArrayValue(this.repInfo["Insulation"].Value, 'Header', 'Paragraph1', 'Value'));

        form.getTextField('insIndicator').setText(this.getValue(this.repInfo['Insulation']['Est. Annual  Savings']));

        form.getTextField('insDetail').setText(this.getArrayValue(this.repInfo["Insulation Attributes"].Values, 'Header', 'Attic Type', 'Value'));
        form.getTextField('insAtticQual').setText(this.getArrayValue(this.repInfo["Insulation Attributes"].Values, 'Header', 'Attic Insulation Quality', 'Value'));
        form.getTextField('insFoundation').setText(this.getArrayValue(this.repInfo["Insulation Attributes"].Values, 'Header', 'Foundation Type', 'Value'));
        form.getTextField('insFoundQual').setText(this.getArrayValue(this.repInfo["Insulation Attributes"].Values, 'Header', 'Foundation Insulation Quality', 'Value'));

        const eleventhPage = pages[10 + pageOffset];

        if (this.repInfo['Insulation']['Potential Measures'].length > 0) {
            eleventhPage.drawRectangle({
                x: 123.5,
                y: 520.0,
                width: 450,
                height: 25,
                color: rgb(0.76, 0.28, 0.07)
            });

            form.getTextField("insMeasureTitle").setText("Potential Measures");

            eleventhPage.drawImage(pngRedImage, {
                x: 36,
                y: 540,
                width: pngRedDims.width,
                height: pngRedDims.height,
            });

            eleventhPage.drawImage(pngCheckImage, {
                x: 123.5,
                y: 485,
                width: pngCheckDims.width,
                height: pngCheckDims.height,
            });

            let asOffset = 502;
            this.repInfo['Insulation']['Potential Measures'].forEach(element => {
                eleventhPage.moveTo(160, asOffset);
                eleventhPage.drawText(element, { size: 10 });
                asOffset -= 12;
            });
        } else
            if (this.repInfo['Insulation']['Savings Indicator'] === 'Green') {
                eleventhPage.drawImage(pngImage, {
                    x: 36,
                    y: 540,
                    width: pngDims.width,
                    height: pngDims.height,
                });
            } else {
                // if not green
                eleventhPage.drawRectangle({
                    x: 426.0,
                    y: 650.2,
                    width: 148,
                    height: 43.75,
                    color: rgb(1.0, 0.6471, 0.0)
                });
            }

        // page 12
        const xSectionName = "Should you get a full home energy audit?";

        form.getTextField('xShould').setText(this.getArrayValue(this.repInfo[xSectionName]["CERTIFIED BPI ENERGY AUDIT"].Value, 'Header', 'Paragraph1', 'Value'));
        form.getTextField('xPartOne').setText(this.getArrayValue(this.repInfo[xSectionName]["PART ONE: THE EVALUATION"].Value, 'Header', 'Paragraph1', 'Value'));
        form.getTextField('xPartTwo').setText(this.getArrayValue(this.repInfo[xSectionName]["PART TWO: THE SUGGESTIONS"].Value, 'Header', 'Paragraph1', 'Value'));

        form.getTextField('xBull1').setText(" - " + this.getArrayValue(this.repInfo[xSectionName]["PART TWO: THE SUGGESTIONS"].Value, 'Header', 'Bulletin1', 'Value'));
        form.getTextField('xBull2').setText(" - " + this.getArrayValue(this.repInfo[xSectionName]["PART TWO: THE SUGGESTIONS"].Value, 'Header', 'Bulletin2', 'Value'));
        form.getTextField('xBull3').setText(" - " + this.getArrayValue(this.repInfo[xSectionName]["PART TWO: THE SUGGESTIONS"].Value, 'Header', 'Bulletin3', 'Value'));
        form.getTextField('xBull4').setText(" - " + this.getArrayValue(this.repInfo[xSectionName]["PART TWO: THE SUGGESTIONS"].Value, 'Header', 'Bulletin4', 'Value'));
        form.getTextField('xBull5').setText(" - " + this.getArrayValue(this.repInfo[xSectionName]["PART TWO: THE SUGGESTIONS"].Value, 'Header', 'Bulletin5', 'Value'));
        form.getTextField('xBull6').setText(" - " + this.getArrayValue(this.repInfo[xSectionName]["PART TWO: THE SUGGESTIONS"].Value, 'Header', 'Bulletin6', 'Value'));
        form.getTextField('xBull7').setText(" - " + this.getArrayValue(this.repInfo[xSectionName]["PART TWO: THE SUGGESTIONS"].Value, 'Header', 'Bulletin7', 'Value'));
        form.getTextField('xBull8').setText(" - " + this.getArrayValue(this.repInfo[xSectionName]["PART TWO: THE SUGGESTIONS"].Value, 'Header', 'Bulletin8', 'Value'));

        form.getTextField('xCosts').setText(this.getArrayValue(this.repInfo[xSectionName]["Costs"].Value, 'Header', 'Paragraph1', 'Value'));
        form.getTextField('xCallUs').setText(this.getArrayValue(this.repInfo[xSectionName]["Footer"].Value, 'Header', 'Paragraph1', 'Value'));

        form.getTextField('xUrl').setText(this.getArrayValue(this.repInfo[xSectionName]["Contact"].Value, 'Header', 'Paragraph1', 'Value'));
        form.getTextField('xEmail').setText(this.getArrayValue(this.repInfo[xSectionName]["Contact"].Value, 'Header', 'Paragraph2', 'Value'));
        form.getTextField('xPhone').setText(this.getArrayValue(this.repInfo[xSectionName]["Contact"].Value, 'Header', 'Paragraph3', 'Value'));

        form.getTextField('xHead1').setText(this.getValue(this.repInfo[xSectionName].Header));
        form.getTextField('xHead2').setText(this.getValue(this.repInfo[xSectionName]["CERTIFIED BPI ENERGY AUDIT"].Header));
        form.getTextField('xHead3').setText(this.getValue(this.repInfo[xSectionName]["PART ONE: THE EVALUATION"].Header));
        form.getTextField('xHead4').setText(this.getValue(this.repInfo[xSectionName]["PART TWO: THE SUGGESTIONS"].Header));

        // page 13
        form.getTextField('rrMainTitle').setText(this.getValue(this.repInfo["References and Resources"].Header));
        form.getTextField('rrInfoTitle').setText(this.getArrayValue(this.repInfo["References and Resources"]["Header2"].Value, 'Header', 'Paragraph2', 'Value'));

        form.getTextField('rrBPI').setText(this.getValue(this.repInfo["References and Resources"]["Building Performance Institute:"].Header));
        form.getTextField('rruBPI').setText(this.getArrayValue(this.repInfo["References and Resources"]["Building Performance Institute:"].Value, 'Header', 'Paragraph1', 'Value'));

        form.getTextField('rrHES').setText(this.getValue(this.repInfo["References and Resources"]["Home Energy Saver:"].Header));
        form.getTextField('rruHES').setText(this.getArrayValue(this.repInfo["References and Resources"]["Home Energy Saver:"].Value, 'Header', 'Paragraph1', 'Value'));

        form.getTextField('rrHPwES').setText(this.getValue(this.repInfo["References and Resources"]["Home Performance with ENERGY STAR:"].Header));
        form.getTextField('rruHPwES').setText(this.getArrayValue(this.repInfo["References and Resources"]["Home Performance with ENERGY STAR:"].Value, 'Header', 'Paragraph1', 'Value'));

        form.getTextField('rrRSN').setText(this.getValue(this.repInfo["References and Resources"]["Residential Services Network"].Header));
        form.getTextField('rruRSN').setText(this.getArrayValue(this.repInfo["References and Resources"]["Residential Services Network"].Value, 'Header', 'Paragraph1', 'Value'));

        form.getTextField('rrESTitle').setText(this.getValue(this.repInfo["References and Resources"]["Energy Saver:"].Header));
        form.getTextField('rruES1').setText(this.getArrayValue(this.repInfo["References and Resources"]["Energy Saver:"].Value, 'Header', 'Paragraph1', 'Value'));
        form.getTextField('rruES2').setText(this.getArrayValue(this.repInfo["References and Resources"]["Energy Saver:"].Value, 'Header', 'Paragraph2', 'Value'));

        form.getTextField('rrOOEETitle').setText(this.getValue(this.repInfo["References and Resources"]["Office of Energy Efficiency and Renewable Energy:"].Header));
        form.getTextField('rruOOEE').setText(this.getArrayValue(this.repInfo["References and Resources"]["Office of Energy Efficiency and Renewable Energy:"].Value, 'Header', 'Paragraph1', 'Value'));

        form.getTextField('rrES').setText(this.getValue(this.repInfo["References and Resources"]["ENERGY STAR:"].Header));
        form.getTextField('rruEStar').setText(this.getArrayValue(this.repInfo["References and Resources"]["ENERGY STAR:"].Value, 'Header', 'Paragraph1', 'Value'));

        // End of filling in data

        form.flatten();
        const pdfBytes = await pdfDoc.save();

        // to display in window
        const blob = new Blob([pdfBytes], { type: 'application/pdf' });

        return blob;
    }
}
